(function () {
    const $body = $('body'),
        saveToBinder = {
            modal: '#saveToBinders-popup',
            notificationInterval: 0,
            init() {
                this.control();
            },
            control() {
                $body.on('click', '.save-to-binders__ctrl', e => {
                    let $el = $(e.target).closest('.save-to-binders__ctrl');
                    this.loadBinders($el, e);
                });

                $(document).on('change', '.save-to-binders__list input[type="checkbox"]', e => {
                    let $el = $(e.target);
                    this.onChange($el, e);
                });
                $(document).on('click', '.binder__toggle-form', e => {
                    e.preventDefault();
                    let $this = $(e.target).closest('.binder__toggle-form'),
                        action = $this.attr('data-action'),
                        $parent = $this.parents('.save-to-binders__create');
                    if (action === 'show') {
                        $('.binder__show-form').fadeOut('fast', function () {
                            setTimeout(function () {
                                $parent.find('.save-to-binders__create__form').fadeIn('fast');
                            }, 200);
                        });
                    } else {
                        $parent.find('.save-to-binders__create__form').hide();
                        $('.binder__show-form').show();
                    }
                });
            },
            loadBinders($el, e) {
                const $modal = $(this.modal);
                let view = 'list',
                    link = $el.attr('data-link'), // real link
                    // link = '/specs/ux3/components/save-to-binder/templates/demo/binders.json', // test link
                    $binderList = $('[data-db-target-of=' + $el.data('db-target-for') + ']').find(
                        '.save-to-binders__list'
                    ),
                    requestNewContent = false;

                if (config.enableSaveToBinderStyleModal) { /*eslint-disable-line*/
                    if ($el.attr('data-modal-toggle') === 'modal') {
                        e.preventDefault();
                        $binderList = $modal.find('.save-to-binders__list');
                        view = 'modal';
                        requestNewContent = true;
                    }
                }

                if ($binderList.find('.rlist').children(':not(.loader)').length === 0) {
                    requestNewContent = true;
                }

                if (requestNewContent) {
                    if (config.enableSaveToBinderStyleModal) { /*eslint-disable-line*/
                        if (view === 'modal') {
                            $modal.removeAttr('data-single-doi');
                            if (typeof $el.attr('data-doi') !== 'undefined') {
                                $modal.attr('data-single-doi', $el.attr('data-doi'));
                            }
                            $modal.modal();
                        }
                    }

                    $.ajax({
                        url: link,
                        type: 'GET',
                        success: function (data) {
                            if (data) {
                                $binderList.find('.loader').remove();
                                if (view === 'modal') {
                                    $binderList.find('.rlist').empty();
                                }
                                data.forEach(function (element) {
                                    if (typeof element.binderName !== 'undefined' && element.binderName !== '') {
                                        let additionalAttr = element.added ? 'checked' : '';
                                        $binderList.find('.rlist')
                                            .append(`<li class="input-group"><label class="checkbox--primary" 
                                            tabindex="0"><input type="checkbox" name="binderCode" 
                                            value="${element.binderCode}" ${additionalAttr} >
                                            <span class="label-txt"><div class="save-to-binders__list__binder-name">${element.binderName}</div></span></label></li>`);
                                    }
                                });
                            }
                        },
                        error: function (data) {
                            if (data.status === 401 && data.responseJSON.url) {
                                location.href = data.responseJSON.url;
                            }
                        },
                    });
                }
            },
            onChange($el, e) {
                $el.attr('disabled', 'disabled');
                $el.next('.label-txt').addClass('disabled');
                let $binderWrapper = $el.closest('.save-to-binders'),
                    $alertElem = $binderWrapper.find('.save-to-binders__alerts'),
                    isAdd = false,
                    link = '/action/removeBinderItem';
                if ($el.prop('checked')) {
                    isAdd = true;
                    link = '/action/addBinderItem'; // real link
                }
                // link = '/specs/ux3/components/save-to-binder/templates/demo/save-binders.json'; // test link

                let multiDois = false, // if modal then it could be multidois, 'data-single-doi' distinguish between multi or single dois
                    dois = '',
                    code,
                    view = 'list';

                if ($el.closest(this.modal).length && config.enableSaveToBinderStyleModal) { /*eslint-disable-line*/
                    multiDois = true;
                    view = 'modal';
                }

                dois = this.defineDois($binderWrapper, multiDois);
                code = $el.val();

                $.ajax({
                    url: link,
                    data: {
                        dois: dois,
                        binderCode: code,
                    },
                    type: 'POST',
                    success: function (data) {
                        $el.removeAttr('disabled');
                        $el.next('.label-txt').removeClass('disabled');
                        if (data.message) {
                            let icon = 'icon-checkmark',
                                msgType = 'success';
                            if (!isAdd) {
                                icon = 'icon-warning-triangle';
                                msgType = 'warning';
                            }
                            let $message = $(
                                `<p class="alert-msg alert-msg--${msgType}"><i class="${icon}"></i>${data.message}</p>`
                            );
                            saveToBinder.showNotification($message, view, $alertElem);
                        }
                    },
                    error: function () {
                        $el.removeAttr('disabled');
                        $el.next('.label-txt').removeClass('disabled');

                        let message = $alertElem.data('error');
                        let $message = $(
                            `<p class="alert-msg alert-msg--error"><i class="icon-notice"></i>${message}</p>`
                        );
                        saveToBinder.showNotification($message, view, $alertElem);
                    },
                });
            },
            defineDois($binderWrapper, multiDois) {
                let dois = '';
                if (multiDois && config.enableSaveToBinderStyleModal) { /*eslint-disable-line*/
                    if (typeof $(this.modal).attr('data-single-doi') !== 'undefined') {
                        dois += $(this.modal).attr('data-single-doi');
                    } else {
                        let $items = $('.issue-item-container .issue-Item__checkbox:checked');
                        $items.each(function (index) {
                            dois += $(this).attr('name');
                            dois += index >= $items.length ? '' : ',';
                        });
                    }
                }
                if (!multiDois) {
                    $binderWrapper.find('[name="doiVal"]').each(function () {
                        dois += $(this).val();
                    });
                }
                return dois;
            },
            showNotification($message, view, $target) {
                if (view === 'list') {
                    $message.addClass('alert-msg--fixed');
                }
                if (this.notificationInterval) {
                    clearTimeout(this.notificationInterval);
                }
                $target.html($message.get(0).outerHTML);
                this.notificationInterval = setTimeout(function () {
                    $target.find('[class*=alert-msg]').fadeOut();
                }, 5000);
            },
        };
    UX.saveToBinder = saveToBinder;
    $(document).ready(function () {
        if ($('.save-to-binders__ctrl').length) {
            UX.saveToBinder.init();
        }
    });
})();
